import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import * as i2 from '@spartacus/core';
import { GlobalMessageType, I18nModule, UrlModule, FeaturesConfigModule, provideDefaultConfig, AuthGuard } from '@spartacus/core';
import * as i1 from '@spartacus/pdf-invoices/root';
import { InvoicesFields } from '@spartacus/pdf-invoices/root';
import * as i3 from '@spartacus/storefront';
import { ICON_TYPE, DatePickerModule, ListNavigationModule, IconModule, MediaModule, SpinnerModule } from '@spartacus/storefront';
import { BehaviorSubject, EMPTY, Subscription, combineLatest } from 'rxjs';
import { switchMap, tap, catchError, skip, take } from 'rxjs/operators';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const _c0 = a0 => ({
  id: a0
});
function InvoicesListComponent_ng_container_0_ng_container_1_div_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "cx-pagination", 12);
    i0.ɵɵlistener("viewPageEvent", function InvoicesListComponent_ng_container_0_ng_container_1_div_15_Template_cx_pagination_viewPageEvent_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.pageChange($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("pagination", ctx_r1.pagination);
  }
}
function InvoicesListComponent_ng_container_0_ng_container_1_thead_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "thead", 13)(1, "th", 14);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "th", 14);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th", 14);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th", 14);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th", 14);
    i0.ɵɵelement(14, "cx-icon", 15);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, "pdfInvoices.invoicesTable.invoiceId"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 8, "pdfInvoices.invoicesTable.createdAt"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(9, 10, "pdfInvoices.invoicesTable.netAmount"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 12, "pdfInvoices.invoicesTable.totalAmount"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(15, 14, "pdfInvoices.invoicesTable.attachment"));
    i0.ɵɵproperty("type", ctx_r1.ICON_TYPE.DOWNLOAD);
  }
}
function InvoicesListComponent_ng_container_0_ng_container_1_thead_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "thead", 13)(1, "tr")(2, "th", 14);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th", 14);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th", 14);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th", 14);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "th", 14);
    i0.ɵɵelement(15, "cx-icon", 15);
    i0.ɵɵpipe(16, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 6, "pdfInvoices.invoicesTable.invoiceId"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 8, "pdfInvoices.invoicesTable.createdAt"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 10, "pdfInvoices.invoicesTable.netAmount"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(13, 12, "pdfInvoices.invoicesTable.totalAmount"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(16, 14, "pdfInvoices.invoicesTable.attachment"));
    i0.ɵɵproperty("type", ctx_r1.ICON_TYPE.DOWNLOAD);
  }
}
function InvoicesListComponent_ng_container_0_ng_container_1_tr_21_button_31_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("click", function InvoicesListComponent_ng_container_0_ng_container_1_tr_21_button_31_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const invoice_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.downloadPDFInvoice(invoice_r5.invoiceId, invoice_r5.externalSystemId));
    });
    i0.ɵɵelement(2, "cx-icon", 15);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelement(4, "span", 25);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const invoice_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind2(1, 4, "pdfInvoices.invoicesTable.attachmentDescription", i0.ɵɵpureFunction1(11, _c0, invoice_r5.invoiceId)));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(3, 7, "pdfInvoices.invoicesTable.download"));
    i0.ɵɵproperty("type", ctx_r1.ICON_TYPE.FILE);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerText", i0.ɵɵpipeBind1(5, 9, "pdfInvoices.invoicesTable.download"));
  }
}
function InvoicesListComponent_ng_container_0_ng_container_1_tr_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 16)(1, "td", 17)(2, "div", 18);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 19);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "td", 20)(8, "div", 18);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 19);
    i0.ɵɵtext(12);
    i0.ɵɵpipe(13, "cxDate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "td", 21)(15, "div", 18);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 19);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(20, "td", 21)(21, "div", 18);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 19);
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(26, "td", 22)(27, "div", 18);
    i0.ɵɵtext(28);
    i0.ɵɵpipe(29, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 19);
    i0.ɵɵtemplate(31, InvoicesListComponent_ng_container_0_ng_container_1_tr_21_button_31_Template, 6, 13, "button", 23);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const invoice_r5 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 10, "pdfInvoices.invoicesTable.invoiceId"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", invoice_r5.invoiceId, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 12, "pdfInvoices.invoicesTable.createdAt"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(13, 14, invoice_r5.createdAt, "longDate"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(17, 17, "pdfInvoices.invoicesTable.netAmount"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (invoice_r5.netAmount == null ? null : invoice_r5.netAmount.formattedValue) ? invoice_r5.netAmount == null ? null : invoice_r5.netAmount.formattedValue : (invoice_r5.netAmount == null ? null : invoice_r5.netAmount.currencyIso) + "\xA0" + (invoice_r5.netAmount == null ? null : invoice_r5.netAmount.value), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(23, 19, "pdfInvoices.invoicesTable.totalAmount"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (invoice_r5.totalAmount == null ? null : invoice_r5.totalAmount.formattedValue) ? invoice_r5.totalAmount == null ? null : invoice_r5.totalAmount.formattedValue : (invoice_r5.totalAmount == null ? null : invoice_r5.totalAmount.currencyIso) + "\xA0" + (invoice_r5.totalAmount == null ? null : invoice_r5.totalAmount.value), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(29, 21, "pdfInvoices.invoicesTable.attachment"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", invoice_r5.invoiceId);
  }
}
function InvoicesListComponent_ng_container_0_ng_container_1_div_23_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "cx-pagination", 26);
    i0.ɵɵlistener("viewPageEvent", function InvoicesListComponent_ng_container_0_ng_container_1_div_23_Template_cx_pagination_viewPageEvent_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.pageChange($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("pagination", ctx_r1.pagination);
  }
}
function InvoicesListComponent_ng_container_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div")(2, "div", 1)(3, "h2");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 2)(7, "div", 3)(8, "label", 4)(9, "span");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "cx-sorting", 5);
    i0.ɵɵpipe(13, "cxTranslate");
    i0.ɵɵpipe(14, "cxTranslate");
    i0.ɵɵlistener("sortListEvent", function InvoicesListComponent_ng_container_0_ng_container_1_Template_cx_sorting_sortListEvent_12_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.sortChange($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(15, InvoicesListComponent_ng_container_0_ng_container_1_div_15_Template, 2, 1, "div", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "table", 7);
    i0.ɵɵpipe(17, "cxTranslate");
    i0.ɵɵtemplate(18, InvoicesListComponent_ng_container_0_ng_container_1_thead_18_Template, 16, 16, "thead", 8)(19, InvoicesListComponent_ng_container_0_ng_container_1_thead_19_Template, 17, 16, "thead", 8);
    i0.ɵɵelementStart(20, "tbody");
    i0.ɵɵtemplate(21, InvoicesListComponent_ng_container_0_ng_container_1_tr_21_Template, 32, 23, "tr", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(22, "div", 10);
    i0.ɵɵtemplate(23, InvoicesListComponent_ng_container_0_ng_container_1_div_23_Template, 2, 1, "div", 6);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const invoicesList_r7 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 12, "pdfInvoices.invoicesTable.header"), " ");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 14, "pdfInvoices.sortBy"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(13, 16, "pdfInvoices.sortBy"));
    i0.ɵɵproperty("sortOptions", ctx_r1.sortOptions)("selectedOption", ctx_r1.sort)("ariaLabel", i0.ɵɵpipeBind1(14, 18, "pdfInvoices.sortInvoices"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", invoicesList_r7.pagination && invoicesList_r7.pagination.totalPages && invoicesList_r7.pagination.totalPages > 1);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(17, 20, "pdfInvoices.invoicesTable.label"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxFeature", "!a11yTableHeaderReadout");
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "a11yTableHeaderReadout");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", invoicesList_r7.invoices);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", invoicesList_r7.pagination && invoicesList_r7.pagination.totalPages && invoicesList_r7.pagination.totalPages > 1);
  }
}
function InvoicesListComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, InvoicesListComponent_ng_container_0_ng_container_1_Template, 24, 22, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const invoicesList_r7 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", invoicesList_r7.pagination && invoicesList_r7.pagination.totalCount && invoicesList_r7.pagination.totalCount > 0);
  }
}
class InvoicesListComponent {
  constructor(pdfInvoicesFacade, translationService, downloadService, languageService, globalMessageService) {
    this.pdfInvoicesFacade = pdfInvoicesFacade;
    this.translationService = translationService;
    this.downloadService = downloadService;
    this.languageService = languageService;
    this.globalMessageService = globalMessageService;
    /* For Enum use in HTML */
    this.ICON_TYPE = ICON_TYPE;
    this.PAGE_SIZE = 5; //Default page size
    this.sort = 'byInvoiceIdAsc';
    this.sortMapping = {
      byCreatedAtAsc: 'createdAt:asc',
      byCreatedAtDesc: 'createdAt:desc',
      byInvoiceIdAsc: 'invoiceId:asc',
      byInvoiceIdDesc: 'invoiceId:desc',
      byNetAmountAsc: 'netAmount:asc',
      byNetAmountDesc: 'netAmount:desc',
      byTotalAmountAsc: 'totalAmount:asc',
      byTotalAmountDesc: 'totalAmount:desc'
    };
    // Contains the initial query parameters and will be updated with current state of filters
    this._initQueryParams = {
      currentPage: 0,
      pageSize: this.PAGE_SIZE,
      fields: InvoicesFields.FULL,
      sort: this.sortMapping[this.sort] //backend supports sort codes like invoiceId:asc
    };
    // Triggers events on chaning the page, sort options
    this.queryParams$ = new BehaviorSubject(this._initQueryParams);
    // Used by template to subscribe to data from documents api
    this.invoicesList$ = this.queryParams$.pipe(switchMap(param => this.pdfInvoicesFacade.getInvoicesForOrder(param)), tap(invoicesList => this.pagination = {
      currentPage: invoicesList.pagination?.page,
      pageSize: invoicesList.pagination?.count,
      totalPages: invoicesList.pagination?.totalPages,
      totalResults: invoicesList.pagination?.totalCount,
      sort: this.sortMapping[this.sort]
    }), catchError(error => {
      if (error && this.getNotEnabledError(error)?.length) {
        this.globalMessageService.add({
          key: 'pdfInvoices.featureNotEnabled'
        }, GlobalMessageType.MSG_TYPE_ERROR);
      }
      return EMPTY;
    }));
    this.subscription = new Subscription();
  }
  ngOnInit() {
    this.subscription.add(this.languageService.getActive().pipe(skip(1)).subscribe(() => this.updateQueryParams({
      fields: InvoicesFields.FULL
    })));
    this.getSortOptions();
  }
  updateQueryParams(partialParams) {
    // Overwrite each value present in partialParams to _queryParams
    Object.keys(partialParams).forEach(key => this._initQueryParams[key] = partialParams[key]);
    // Every request that doesn't specify fields should be set to DEFAULT
    if (!partialParams.fields) {
      this._initQueryParams.fields = InvoicesFields.DEFAULT;
    }
    this.queryParams$.next(this._initQueryParams);
  }
  pageChange(currentPage) {
    this.updateQueryParams({
      currentPage: currentPage
    });
  }
  sortChange(sortCode) {
    this.sort = sortCode;
    this.updateQueryParams({
      sort: this.sortMapping[sortCode],
      //backend supports sort codes like invoiceId:asc
      currentPage: 0
    });
  }
  downloadPDFInvoice(invoiceId, externalSystemId) {
    this.pdfInvoicesFacade.getInvoicePDF(invoiceId, externalSystemId).pipe(take(1)).subscribe({
      next: data => {
        const file = new Blob([data], {
          type: data.type
        });
        const url = URL.createObjectURL(file);
        this.downloadService.download(url, `${invoiceId}.pdf`);
      }
    });
  }
  getSortOptions() {
    this.sortOptions = [];
    Object.keys(this.sortMapping).forEach(sortKey => this.sortOptions.push({
      code: sortKey,
      selected: false
    }));
    const translations = this.sortOptions.map(sort => this.translationService.translate(`pdfInvoices.sorts.${sort.code}`));
    combineLatest(translations).pipe(take(1)).subscribe(translated => this.sortOptions.forEach((sort, index) => sort.name = translated[index]));
  }
  getNotEnabledError(response) {
    return response?.details ? response.details.filter(error => error?.type === 'UnknownResourceError') : [];
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  static {
    this.ɵfac = function InvoicesListComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InvoicesListComponent)(i0.ɵɵdirectiveInject(i1.PDFInvoicesFacade), i0.ɵɵdirectiveInject(i2.TranslationService), i0.ɵɵdirectiveInject(i3.FileDownloadService), i0.ɵɵdirectiveInject(i2.LanguageService), i0.ɵɵdirectiveInject(i2.GlobalMessageService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: InvoicesListComponent,
      selectors: [["cx-invoices-list"]],
      standalone: false,
      decls: 2,
      vars: 3,
      consts: [[4, "ngIf"], [1, "cx-invoices-list-header"], [1, "cx-invoices-list-body"], [1, "cx-invoices-list-sort", "top"], [1, "cx-invoices-list-form-group", "form-group"], ["ariaControls", "cx-invoices-list-table", 3, "sortListEvent", "sortOptions", "selectedOption", "placeholder", "ariaLabel"], ["class", "cx-invoices-list-pagination", 4, "ngIf"], ["id", "cx-invoices-list-table", 1, "table", "cx-invoices-list-table"], ["class", "cx-invoices-list-thead-mobile", 4, "cxFeature"], ["class", "cx-invoices-list-row", 4, "ngFor", "ngForOf"], [1, "cx-invoices-list-sort", "bottom"], [1, "cx-invoices-list-pagination"], ["paginationID", "pagination-top", 3, "viewPageEvent", "pagination"], [1, "cx-invoices-list-thead-mobile"], ["scope", "col"], [1, "cx-invoices-list-attachment-icon", 3, "type", "title"], [1, "cx-invoices-list-row"], [1, "cx-invoices-list-code"], [1, "cx-invoices-list-label"], [1, "cx-invoices-list-value"], [1, "cx-invoices-list-date"], [1, "cx-invoices-list-monetary"], [1, "cx-invoices-list-attachment"], ["class", "cx-invoices-list-attachment-btn", 3, "click", 4, "ngIf"], [1, "cx-invoices-list-attachment-btn", 3, "click"], [1, "cx-invoices-list-attachment-text", 3, "innerText"], ["paginationID", "pagination-bottom", 3, "viewPageEvent", "pagination"]],
      template: function InvoicesListComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, InvoicesListComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.invoicesList$));
        }
      },
      dependencies: [i4.NgForOf, i4.NgIf, i3.SortingComponent, i3.PaginationComponent, i3.IconComponent, i2.FeatureDirective, i4.AsyncPipe, i2.TranslatePipe, i2.CxDatePipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(InvoicesListComponent, [{
    type: Component,
    args: [{
      selector: 'cx-invoices-list',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-container *ngIf=\"invoicesList$ | async as invoicesList\">\n  <ng-container\n    *ngIf=\"\n      invoicesList.pagination &&\n      invoicesList.pagination.totalCount &&\n      invoicesList.pagination.totalCount > 0\n    \"\n  >\n    <div>\n      <!-- HEADER -->\n      <div class=\"cx-invoices-list-header\">\n        <h2>\n          {{ 'pdfInvoices.invoicesTable.header' | cxTranslate }}\n        </h2>\n      </div>\n\n      <!-- BODY -->\n      <div class=\"cx-invoices-list-body\">\n        <div class=\"cx-invoices-list-sort top\">\n          <label class=\"cx-invoices-list-form-group form-group\">\n            <span>\n              {{ 'pdfInvoices.sortBy' | cxTranslate }}\n            </span>\n            <cx-sorting\n              [sortOptions]=\"sortOptions\"\n              (sortListEvent)=\"sortChange($event)\"\n              [selectedOption]=\"sort\"\n              placeholder=\"{{ 'pdfInvoices.sortBy' | cxTranslate }}\"\n              [ariaLabel]=\"'pdfInvoices.sortInvoices' | cxTranslate\"\n              ariaControls=\"cx-invoices-list-table\"\n            ></cx-sorting>\n          </label>\n          <div\n            class=\"cx-invoices-list-pagination\"\n            *ngIf=\"\n              invoicesList.pagination &&\n              invoicesList.pagination.totalPages &&\n              invoicesList.pagination.totalPages > 1\n            \"\n          >\n            <cx-pagination\n              [pagination]=\"pagination\"\n              (viewPageEvent)=\"pageChange($event)\"\n              paginationID=\"pagination-top\"\n            ></cx-pagination>\n          </div>\n        </div>\n\n        <!-- TABLE -->\n        <table\n          id=\"cx-invoices-list-table\"\n          class=\"table cx-invoices-list-table\"\n          attr.aria-label=\"{{\n            'pdfInvoices.invoicesTable.label' | cxTranslate\n          }}\"\n        >\n          <thead\n            *cxFeature=\"'!a11yTableHeaderReadout'\"\n            class=\"cx-invoices-list-thead-mobile\"\n          >\n            <th scope=\"col\">\n              {{ 'pdfInvoices.invoicesTable.invoiceId' | cxTranslate }}\n            </th>\n            <th scope=\"col\">\n              {{ 'pdfInvoices.invoicesTable.createdAt' | cxTranslate }}\n            </th>\n            <th scope=\"col\">\n              {{ 'pdfInvoices.invoicesTable.netAmount' | cxTranslate }}\n            </th>\n            <th scope=\"col\">\n              {{ 'pdfInvoices.invoicesTable.totalAmount' | cxTranslate }}\n            </th>\n            <th scope=\"col\">\n              <cx-icon\n                [type]=\"ICON_TYPE.DOWNLOAD\"\n                class=\"cx-invoices-list-attachment-icon\"\n                title=\"{{\n                  'pdfInvoices.invoicesTable.attachment' | cxTranslate\n                }}\"\n              ></cx-icon>\n            </th>\n          </thead>\n          <thead\n            *cxFeature=\"'a11yTableHeaderReadout'\"\n            class=\"cx-invoices-list-thead-mobile\"\n          >\n            <tr>\n              <th scope=\"col\">\n                {{ 'pdfInvoices.invoicesTable.invoiceId' | cxTranslate }}\n              </th>\n              <th scope=\"col\">\n                {{ 'pdfInvoices.invoicesTable.createdAt' | cxTranslate }}\n              </th>\n              <th scope=\"col\">\n                {{ 'pdfInvoices.invoicesTable.netAmount' | cxTranslate }}\n              </th>\n              <th scope=\"col\">\n                {{ 'pdfInvoices.invoicesTable.totalAmount' | cxTranslate }}\n              </th>\n              <th scope=\"col\">\n                <cx-icon\n                  [type]=\"ICON_TYPE.DOWNLOAD\"\n                  class=\"cx-invoices-list-attachment-icon\"\n                  title=\"{{\n                    'pdfInvoices.invoicesTable.attachment' | cxTranslate\n                  }}\"\n                ></cx-icon>\n              </th>\n            </tr>\n          </thead>\n          <tbody>\n            <tr\n              *ngFor=\"let invoice of invoicesList.invoices\"\n              class=\"cx-invoices-list-row\"\n            >\n              <td class=\"cx-invoices-list-code\">\n                <div class=\"cx-invoices-list-label\">\n                  {{ 'pdfInvoices.invoicesTable.invoiceId' | cxTranslate }}\n                </div>\n                <div class=\"cx-invoices-list-value\">\n                  {{ invoice.invoiceId }}\n                </div>\n              </td>\n              <td class=\"cx-invoices-list-date\">\n                <div class=\"cx-invoices-list-label\">\n                  {{ 'pdfInvoices.invoicesTable.createdAt' | cxTranslate }}\n                </div>\n                <div class=\"cx-invoices-list-value\">\n                  {{ invoice.createdAt | cxDate: 'longDate' }}\n                </div>\n              </td>\n              <td class=\"cx-invoices-list-monetary\">\n                <div class=\"cx-invoices-list-label\">\n                  {{ 'pdfInvoices.invoicesTable.netAmount' | cxTranslate }}\n                </div>\n                <div class=\"cx-invoices-list-value\">\n                  {{\n                    invoice.netAmount?.formattedValue\n                      ? invoice.netAmount?.formattedValue\n                      : invoice.netAmount?.currencyIso +\n                        '&nbsp;' +\n                        invoice.netAmount?.value\n                  }}\n                </div>\n              </td>\n              <td class=\"cx-invoices-list-monetary\">\n                <div class=\"cx-invoices-list-label\">\n                  {{ 'pdfInvoices.invoicesTable.totalAmount' | cxTranslate }}\n                </div>\n                <div class=\"cx-invoices-list-value\">\n                  {{\n                    invoice.totalAmount?.formattedValue\n                      ? invoice.totalAmount?.formattedValue\n                      : invoice.totalAmount?.currencyIso +\n                        '&nbsp;' +\n                        invoice.totalAmount?.value\n                  }}\n                </div>\n              </td>\n              <td class=\"cx-invoices-list-attachment\">\n                <div class=\"cx-invoices-list-label\">\n                  {{ 'pdfInvoices.invoicesTable.attachment' | cxTranslate }}\n                </div>\n                <div class=\"cx-invoices-list-value\">\n                  <button\n                    *ngIf=\"invoice.invoiceId\"\n                    class=\"cx-invoices-list-attachment-btn\"\n                    (click)=\"\n                      downloadPDFInvoice(\n                        invoice.invoiceId,\n                        invoice.externalSystemId\n                      )\n                    \"\n                    attr.aria-label=\"{{\n                      'pdfInvoices.invoicesTable.attachmentDescription'\n                        | cxTranslate\n                          : {\n                              id: invoice.invoiceId,\n                            }\n                    }}\"\n                  >\n                    <cx-icon\n                      [type]=\"ICON_TYPE.FILE\"\n                      class=\"cx-invoices-list-attachment-icon\"\n                      title=\"{{\n                        'pdfInvoices.invoicesTable.download' | cxTranslate\n                      }}\"\n                    >\n                    </cx-icon>\n                    <span\n                      class=\"cx-invoices-list-attachment-text\"\n                      [innerText]=\"\n                        'pdfInvoices.invoicesTable.download' | cxTranslate\n                      \"\n                    >\n                    </span>\n                  </button>\n                </div>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n\n        <!-- Select Form and Pagination Bottom -->\n        <div class=\"cx-invoices-list-sort bottom\">\n          <div\n            class=\"cx-invoices-list-pagination\"\n            *ngIf=\"\n              invoicesList.pagination &&\n              invoicesList.pagination.totalPages &&\n              invoicesList.pagination.totalPages > 1\n            \"\n          >\n            <cx-pagination\n              [pagination]=\"pagination\"\n              (viewPageEvent)=\"pageChange($event)\"\n              paginationID=\"pagination-bottom\"\n            ></cx-pagination>\n          </div>\n        </div>\n      </div>\n    </div>\n  </ng-container>\n</ng-container>\n"
    }]
  }], () => [{
    type: i1.PDFInvoicesFacade
  }, {
    type: i2.TranslationService
  }, {
    type: i3.FileDownloadService
  }, {
    type: i2.LanguageService
  }, {
    type: i2.GlobalMessageService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class PDFInvoicesComponentsModule {
  static {
    this.ɵfac = function PDFInvoicesComponentsModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PDFInvoicesComponentsModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: PDFInvoicesComponentsModule,
      declarations: [InvoicesListComponent],
      imports: [CommonModule, DatePickerModule, I18nModule, ReactiveFormsModule, ListNavigationModule, UrlModule, IconModule, MediaModule, SpinnerModule, FeaturesConfigModule],
      exports: [InvoicesListComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig({
        cmsComponents: {
          AccountOrderDetailsPDFInvoicesComponent: {
            component: InvoicesListComponent,
            guards: [AuthGuard]
          }
        }
      })],
      imports: [CommonModule, DatePickerModule, I18nModule, ReactiveFormsModule, ListNavigationModule, UrlModule, IconModule, MediaModule, SpinnerModule, FeaturesConfigModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PDFInvoicesComponentsModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, DatePickerModule, I18nModule, ReactiveFormsModule, ListNavigationModule, UrlModule, IconModule, MediaModule, SpinnerModule, FeaturesConfigModule],
      declarations: [InvoicesListComponent],
      exports: [InvoicesListComponent],
      providers: [provideDefaultConfig({
        cmsComponents: {
          AccountOrderDetailsPDFInvoicesComponent: {
            component: InvoicesListComponent,
            guards: [AuthGuard]
          }
        }
      })]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { InvoicesListComponent, PDFInvoicesComponentsModule };
